import WalletsUpgradeLogoutModal from './wallets-upgrade-logout-modal';

export default WalletsUpgradeLogoutModal;
